jQuery(document).ready(function() {
 $('.slfe-light-dark-switch_dark_btn').click(function(){
  localStorage.setItem('dark-mode', 'True');
  $('.slfe-light-dark-switch').addClass('dark');
  $('.slfe-light-dark-switch_light_btn').addClass('dark');
  $('.slfe-light-dark-switch_dark_btn').addClass('dark');
  $('body').addClass('dark');
  $('.header, .menu-drawer, .header__submenu, .menu-drawer__submenu, .search-modal__content, .cart-notification').addClass('dark');
  $('.header__heading-logo, .header__heading-logo_dark').addClass('dark');
  $('.link, .header__active-menu-item, .header__icon').addClass('dark');
  $('.h0, .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6').addClass('dark');
  $('.bg-2--text, .price, .product-info-block_title').addClass('dark');
  $('.product-form__input input[type="radio"] + .color-swatch, .product-form__input input[type=radio]+label').addClass('dark');
  $('.field__input, .field__label, .article-card__info, .slfe-light-dark-uniclass, .slider-button, .jdgm-sort-dropdown, .jdgm-form-wrapper').addClass('dark');
 });

 $('.slfe-light-dark-switch_light_btn').click(function(){
  localStorage.setItem('dark-mode', 'False');
  document.body.style.backgroundColor = "";
  $('.slfe-light-dark-switch').removeClass('dark');
  $('.slfe-light-dark-switch_light_btn').removeClass('dark');
  $('.slfe-light-dark-switch_dark_btn').removeClass('dark');
  $('body').removeClass('dark');
  $('.header, .menu-drawer, .header__submenu, .menu-drawer__submenu, .search-modal__content, .cart-notification').removeClass('dark');
  $('.header__heading-logo, .header__heading-logo_dark').removeClass('dark');
  $('.link, .header__active-menu-item, .header__icon').removeClass('dark');
  $('.h0, .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6').removeClass('dark');
  $('.bg-2--text, .price, .product-info-block_title').removeClass('dark');
  $('.product-form__input input[type="radio"] + .color-swatch, .product-form__input input[type=radio]+label').removeClass('dark');
  $('.field__input, .field__label, .article-card__info, .slfe-light-dark-uniclass, .slider-button, .jdgm-sort-dropdown, .jdgm-form-wrapper').removeClass('dark');
 });


 $('.product__info-container').click(function(){
  setTimeout(function (){
   if ( localStorage.getItem('dark-mode') === "True" ) {
   $('.price').addClass('dark');
  }
  },560);
 });
 if ( localStorage.getItem('dark-mode') === "True" ) {
  $('.price').addClass('dark');
 }
 $('.product-form__submit').click(function(){
  setTimeout(function (){
   if ( localStorage.getItem('dark-mode') === "True" ) {
   $('.cart-notification-product__name, .product-option, #cart-notification-button').addClass('dark');
  }
  },960);
 });
 $('.cart__items').on("change", function(){
  setTimeout(function (){
   if ( localStorage.getItem('dark-mode') === "True" ) {
   $('.slfe-light-dark-uniclass, .price').addClass('dark');
  }
  },1560);
 });
 if ( localStorage.getItem('dark-mode') === "True" ) {
  setTimeout(function (){
   $('.jdgm-sort-dropdown, .jdgm-form-wrapper').addClass('dark');
  },1760);
 }
});